import React, { useState } from 'react';
import { API_BASE_URL } from '../../../config/api';
import './ApiTest.css';

interface TestResponse {
  message?: string;
  status?: string;
  timestamp?: string;
  test_info?: Record<string, string>;
}

const ApiTest: React.FC = () => {
  const [result, setResult] = useState<TestResponse | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleTestApi = async () => {
    setLoading(true);
    setResult(null);
    setError(null);

    try {
      const response = await fetch(`${API_BASE_URL}/ingestion/test/`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      const data = await response.json();

      if (response.ok) {
        setResult(data);
      } else {
        setError(data.message || data.detail || `HTTP ${response.status}`);
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Request failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="api-test">
      <h1 className="api-test__title">API Test</h1>
      <p className="api-test__desc">
        Hit the button to call the Django API at <code>{API_BASE_URL}</code>.
      </p>
      <button
        type="button"
        className="api-test__button"
        onClick={handleTestApi}
        disabled={loading}
      >
        {loading ? 'Calling…' : 'Test API'}
      </button>

      {result && (
        <div className="api-test__result api-test__result--success">
          <h2>Response</h2>
          <pre>{JSON.stringify(result, null, 2)}</pre>
        </div>
      )}
      {error && (
        <div className="api-test__result api-test__result--error">
          <h2>Error</h2>
          <p>{error}</p>
        </div>
      )}
    </div>
  );
};

export default ApiTest;
